export function mailProtect() {
    let links = document.querySelectorAll('a');
    links.forEach(function (item) {
        if (item.getAttribute('data-mailto-token') != null) {
            item.innerHTML = item.innerHTML.replace('@~@', '@');
            if (!item.classList.contains('mail-button')) {
                item.setAttribute("href", 'mailto:' + item.innerHTML);
            }
        }
    });
}
